const RESIDENCE_USER_ROLE = {
  resident: 'resident',
  manager: 'manager',
  animator: 'animator',
  jardinier: 'jardinier',
  union_advisor: 'union-advisor',
};

export default RESIDENCE_USER_ROLE;
